<template>
   <AdviceModal @closeModal="$emit('closeModal')" :disableCross="true">
      <div class="box">
         <div class="box-content">
            <Typography :weigth="'weigth'" :size="'bigger'" class="title">
               {{ $t('Advice.deleteUserText') }}
            </Typography>
            <div class="btns">
               <SWButton :disabled="isDeleting" @click.native="$emit('closeModal')">
                  <Typography class="btnText">{{ $t('Advice.btnCancel') }}</Typography>
               </SWButton>
               <SWButton :disabled="isDeleting" @click.native="triggerDeleteUser">
                  <Typography class="btnText">
                     {{ $t('Account.changeStateConfirm') }}
                  </Typography>
               </SWButton>
            </div>
         </div>
      </div>
   </AdviceModal>
</template>

<script>
import { SWButton } from 'sw-ui-kit';
import AdviceModal from '../../../components/AdviceComponents/AdviceModal.vue';
import Typography from '../../../components/UI/Typography.vue';

export default {
   components: {
      AdviceModal,
      Typography,
      SWButton,
   },

   data() {
      return {
         isDeleting: false,
      };
   },

   methods: {
      async deleteUser() {
         try {
            // backend endpoint to delete user data
            const response = await this.$http.post('resources/profile/remove');

            const status = response && response.status ? response.status : 0;
            console.log('deleteUser status:', status);

            if (status >= 200 && status < 300) {
               this.onDeleteSuccess();
            } else {
               this.onDeleteError(response && response.data);
            }
         } catch (error) {
            const res = error && error.response ? error.response : null;

            // if backend says "user not found" — consider it already deleted
            if (
               res &&
               res.status === 400 &&
               res.data &&
               typeof res.data.message === 'string' &&
               res.data.message.toLowerCase().includes('not found')
            ) {
               this.onDeleteSuccess();
               return;
            }

            console.error('Error deleting user:', error);
            this.onDeleteError(res && res.data);
         }
      },

      onDeleteSuccess() {
         //  Clear all important data from localStorage
         try {
            localStorage.removeItem('user_token');
            localStorage.removeItem('token');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
         } catch (e) {
            console.warn('Error clearing localStorage tokens:', e);
         }

         // don't forget sessionStorage too — for the flag that user deleted account

         try {
            sessionStorage.setItem('account_deleted', 'true');
            console.log('account_deleted flag set to true in sessionStorage');
         } catch (e) {
            console.warn('Error setting account_deleted flag:', e);
         }

         // Close the modal and navigate to login
         this.$emit('closeModal');
         this.$router.replace({ name: 'login' });
         // if something caches strangely — you can add:
         // window.location.reload();
      },

      onDeleteError(data) {
         console.log('Delete user error response:', data);

         if (this.$notify) {
            this.$notify({
               type: 'error',
               text:
                  this.$t('Account.delete_failed') ||
                  'We couldn\'t delete your account. Please try again later.',
            });
         }
      },

      async triggerDeleteUser() {
         if (this.isDeleting) return;
         this.isDeleting = true;

         try {
            await this.deleteUser();
         } finally {
            this.isDeleting = false;
         }
      },
   },
};
</script>

<style scoped>
.box {
   max-width: 400px;
   width: 100%;
   height: 380px;
   margin: 0 auto;
   background: var(--bg-modal-dark);
}

.title {
   text-align: center;
}
.box-content {
   transform: translateY(120px);
}
.btns {
   margin-top: 60px;
   display: flex;
   justify-content: space-around;
}
.btnText {
   color: white !important;
}
</style>
